import { render, staticRenderFns } from "./survey-done.scene.vue?vue&type=template&id=bc2a8fca"
import script from "./survey-done.scene.ts?vue&type=script&lang=ts&external"
export * from "./survey-done.scene.ts?vue&type=script&lang=ts&external"
import style0 from "./survey-done.scene.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports